import FetchSettings from "../../interfaces/FetchSettings";
import { DataFolderAnnouncementsResponse } from "../../interfaces/OcontentResponses";
import OcontentProvider from "./OcontentProvider";

export default class OcontentAnnouncementsProvider extends OcontentProvider {
  protected _baseUrl = this.baseUrl + "announcements/";

  async getConfig(
    name: string
  ): Promise<Array<DataFolderAnnouncementsResponse>> {
    try {
      const url = new URL(this._baseUrl + name + ".json");
      const settings: FetchSettings = {
        method: "GET",
      };

      const res: Response = await this.request<Response>(
        url.toString(),
        settings,
        true
      );
      if (res.ok) {
        const data: Array<DataFolderAnnouncementsResponse> = await res.json();
        return data;
      }
    } catch (err) {
      console.error(err);
    }
    return [];
  }
}
